import React from "react";
import { PageHero, PageBody } from "./_shared";
import { useFood } from "./FoodLayout";
import BodyMembersTable from "@/components/BodyMembersTable";

export default function ExecutiveBodyPage() {
  const data = useFood();
  const list = data.executive_body || [];
  return (
    <div data-testid="ft-eb-page-wrap">
      <PageHero eyebrow="About" title="Executive Body Members" />
      <PageBody>
        <BodyMembersTable members={list} theme="orange" testidPrefix="ft-eb-page" />
      </PageBody>
    </div>
  );
}
